<template>
  <div style="display: flex;height: 100%;">
    <!-- 科室列表 -->
    <div class="department-intro-department-list">
      <div
        v-for="(item, index) in departmentList"
        :key="index"
        :class="
          item.departmentId == currentDepartmentId
            ? 'department-intro-department-list-item-selected'
            : ''
        "
        @click="changeDepartment(item)"
        class="department-intro-department-list-item"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 医生列表 -->
    <div class="department-intro-detail">
      <div class="title">科室介绍</div>
      <div v-html="detail.intro" class="van-multi-ellipsis--l3"></div>
      <div @click="showDetail" style="right: 0;float: right;color: #108eee;">
        查看更多
      </div>
      <div class="title" style="margin-top: 2rem;">团队介绍</div>
      <div>{{ detail.team }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departmentList: [],
      currentDepartmentId: "",
      detail: {}
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_DEPARTMENT_INTRODUCE_LIST).then(res => {
      this.departmentList = res.departmentList;
      if (this.departmentList.length) {
        this.currentDepartmentId = this.departmentList[0].departmentId;
        this.loadDetail();
      }
    });
  },
  methods: {
    changeDepartment(item) {
      this.currentDepartmentId = item.departmentId;
      this.loadDetail();
    },
    loadDetail() {
      this.$http
        .post(this.$api.REFERENCE_DEPARTMENT_INTRODUCE_DETAIL, {
          departmentId: this.currentDepartmentId
        })
        .then(res => {
          this.detail = res.department;
        });
    },
    showDetail() {
      this.$router.push({
        name: "department-introduction-detail",
        params: this.detail
      });
    }
  }
};
</script>

<style lang="less" scoped>
.department-intro-department-list {
  width: 30%;
  height: 100%;
  overflow: scroll;
  background: #f7f7f7;
}
.department-intro-department-list-item {
  padding: 1rem 0;
  color: black;
  line-height: 1rem;
  text-align: center;
}
.department-intro-department-list-item-selected {
  color: #108ee9;
  background: white;
}
.department-intro-detail {
  width: 70%;
  padding: 1rem;
  color: gray;

  .title {
    margin: 1rem 0;
    color: black;
    font-weight: 600;
    font-size: 1.06rem;
  }
}
</style>
